import React from 'react';
import InputMask from 'react-input-mask'
import { connect } from 'react-redux';

import { answerQuestion } from '../../../../../_actions/questionnaire.actions';

import MedicationSearch from './MedicationSearch';

const ShortText = ({ question, answers, dispatch }) => {
  const answer = answers.find((answer) => {
    return answer.linkId === question.linkId
  });

  const itemControl = question.extension.find((extension) => {
    return extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl';
  });

  return <>
    <h6 className="card-title">{question.linkId}. {question.text || 'Enter your question.'}</h6>

    {!itemControl &&
      <input
        onChange={(e) => {
          dispatch(answerQuestion(question, e.target.value))
        }}
        defaultValue={answer ? answer.answer : ''}
        type="text" className="form-control" />
    }

    {itemControl && itemControl.valueCodeableConcept.coding[0].code === 'phone-number' &&
      <InputMask
        onChange={(e) => { dispatch(answerQuestion(question, e.target.value)) }}
        defaultValue={answer ? answer.answer : ''}
        className="form-control"
        type="text"
        inputMode="numeric"
        mask="999-999-9999"
      />
    }

    {itemControl && itemControl.valueCodeableConcept.coding[0].code === 'medication-search' &&
      <MedicationSearch
        question={question}
        dispatch={(medications) => dispatch(answerQuestion(question, medications))} />
    }
  </>;
}

const mapStateToProps = state => {
  return {
    answers: state.questionnaire.answers
  }
}

export default connect(mapStateToProps)(ShortText);